export default {
  API_STRING: '/admin/api/collections/get',
  SLIDER_IMAGE:
    '/admin/api/collections/get/slidersItems?token=c33bf78fd83fa2fb9dd9094e27910f',
  API_FORM_STRING:
    '/admin/api/forms/submit/contact?token=c33bf78fd83fa2fb9dd9094e27910f',
  PRODUCTS_COLLECTION_NAME: 'products',
  PAGES_COLLECTION_NAME: 'pages',
  MAINPAGE_COLLECTION_NAME: 'mainpage',
  PRODUCTPAGE_FIELDS_COLLECTION_NAME: 'productspage',
  FEATURE_COLLECTION_NAME: 'mainpage_features',
  MENU_COLLECTION_NAME: 'menu',
  FORMFIELDS_COLLECTION_NAME: 'form',
  LANGUAGES: ['gr'],
};
